import {useMemo} from 'react'
import {LanguageSwitcher, type LanguageSwitcherOption} from '@org/ui'
import {getLanguagePath, getCurrentLanguage, getEnabledLanguages} from '@/lib/languages'
import {usePathname} from 'next/navigation'
import { siteConfig } from '@/lib/config/site-config'

interface LangProps {
    showLanguageSwitch?: boolean;
}

export default function Lang({ showLanguageSwitch }: LangProps) {
    const pathname = usePathname() || '/'
    const enabledLanguages = getEnabledLanguages()
    const currentLang = enabledLanguages.length > 0 ? getCurrentLanguage(pathname) : null

    // Используем глобальную настройку, если пропс не передан
    const shouldShowSwitch = showLanguageSwitch !== undefined ? showLanguageSwitch : siteConfig.general.showLanguageSwitch
    
    // Если отключено через пропс/конфигурацию или только один активный язык, не показываем переключатель
    if (!shouldShowSwitch || enabledLanguages.length <= 1) {
        return null
    }

    const languageOptions = useMemo<LanguageSwitcherOption[]>(() => {
        return enabledLanguages.map((lang) => ({
            code: lang.code,
            label: lang.name,
            nativeName: lang.nativeName,
            icon: lang.icon,
            href: getLanguagePath(lang.code, pathname),
        }));
    }, [enabledLanguages, pathname]);

    if (!currentLang) {
        return null;
    }

    return (
        <LanguageSwitcher
            languages={languageOptions}
            currentLanguageCode={currentLang.code}
            className="flex-1"
            renderCurrentLanguage={(language) => (
                <span className="flex items-center gap-2">
                    {language.icon && (
                        <img
                            src={language.icon}
                            alt={language.label}
                            className="size-5 rounded-full object-cover"
                            aria-hidden="true"
                        />
                    )}
                    <span className="truncate hidden xl:inline">{language.label}</span>
                </span>
            )}
        />
    )
}
